import React, { useRef } from 'react';
import { Form, Input } from 'formik-antd';
import { Formik } from 'formik';
import { Button, Modal } from 'antd';
import * as Yup from 'yup';

import FormItem from 'components/formik/FormItem';
import SubmitButton from 'components/formik/SubmitButton';
import { BaseModal, BaseModalFooter } from 'components/wrappers/BaseModal';

import styles from './RespondToRequestModal.module.less';

type Props = {
  onClose: () => void;
  requestMessage: string;
  onResponseSent: (responseMsg: string) => Promise<void>;
};

interface FormValues {
  response: string;
}

const validationSchema = Yup.object({
  response: Yup.string()
    .required('Field is required')
    .max(1000, 'Response should be 1000 characters maximum'),
});

export default function RespondToRequestModal(props: Props) {
  const { onClose, onResponseSent, requestMessage } = props;
  const formRef: any = useRef();

  const handleSubmit = async (values: FormValues) => {
    const { response } = values;

    await onResponseSent(response);
    onClose();
  };

  const handleModalCancel = () => {
    if (formRef.current.isSubmitting) return;

    if (formRef.current?.dirty) {
      return Modal.confirm({
        title: 'Are you sure? The data will not be saved.',
        icon: <span className="icon icon-attention-filled" />,
        onOk() {
          onClose();
        },
        onCancel() {},
      });
    }

    onClose();
  };

  return (
    <BaseModal
      title="Request details"
      open={true}
      maxWidth={468}
      onCancel={handleModalCancel}
    >
      <Formik
        initialValues={{ response: '' }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        <Form layout="vertical">
          <div className="modal-scroll-wrapper">
            <div className={styles.title}>Admin request:</div>
            <div className={styles.request}>{requestMessage}</div>

            <FormItem
              data-id="responseField"
              label="Response *"
              name="response"
            >
              <Input.TextArea
                name="response"
                placeholder="Enter your response"
                autoSize={{ minRows: 8, maxRows: 8 }}
              />
            </FormItem>
          </div>

          <BaseModalFooter>
            <Button data-id="closeResponseModalBtn" onClick={handleModalCancel}>
              Cancel
            </Button>

            <SubmitButton data-id="sendResponseBtn">Send</SubmitButton>
          </BaseModalFooter>
        </Form>
      </Formik>
    </BaseModal>
  );
}
